"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var isSameDay = require("date-fns/is_same_day");
var date_utils_1 = require("./date_utils");
var date_1 = require("../../../utils/date");
var dateFormat_1 = require("../../../utils/dateFormat");
var DateInput = /** @class */ (function (_super) {
    __extends(DateInput, _super);
    function DateInput(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event) {
            if (_this.props.onChange) {
                _this.props.onChange(event);
            }
            if (_this.props.onChangeRaw) {
                _this.props.onChangeRaw(event);
            }
            if (!event.defaultPrevented) {
                _this.changeDate(event.target.value);
            }
        };
        _this.handleBlur = function (event) {
            _this.setState({
                value: _this.safeDateFormat(_this.props)
            });
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };
        _this.state = {
            value: _this.safeDateFormat(_this.props)
        };
        return _this;
    }
    DateInput.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.date !== prevProps.date &&
            (this.resolvesToOtherDate(this.props.date, this.state.value) ||
                this.isOtherInvalidDate(this.props.date, this.state.value) ||
                this.props.locale !== prevProps.locale ||
                this.props.dateFormat !== prevProps.dateFormat)) {
            this.setState({
                value: this.safeDateFormat(this.props)
            });
        }
    };
    DateInput.prototype.formatDateInputValue = function (value) {
        var oldValue = this.state.value;
        // In case the user has deleted a char don't format the new input, because
        // otherwise dots would be appended again after deleting them.
        if (value.length < oldValue.length) {
            return value;
        }
        // Omit any chars that are not necessary for a valid date.
        if (value.length >= '01.01.1970'.length) {
            return value.substring(0, 10);
        }
        return this.props.autoFormatDate(value);
    };
    DateInput.prototype.changeDate = function (value) {
        var formatActivated = typeof this.props.autoFormatDate === 'function';
        var newValue = formatActivated ? this.formatDateInputValue(value) : value;
        if (this.props.onChangeDate) {
            var date = date_1.parse(newValue, this.props.dateFormat, this.props.locale);
            if (date && !date_utils_1.isDayDisabled(date, this.props)) {
                this.props.onChangeDate(date);
            }
            else if (newValue === '') {
                this.props.onChangeDate(null);
            }
        }
        this.setState({ value: newValue });
    };
    DateInput.prototype.safeDateFormat = function (props) {
        if (props.date) {
            if (props.date instanceof Date) {
                return dateFormat_1.format(props.date, props.dateFormat, props.locale);
            }
            return props.date;
        }
        return '';
    };
    DateInput.prototype.focus = function () {
        this.input.focus();
    };
    DateInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, autoFormatDate = _a.autoFormatDate, customInput = _a.customInput, date = _a.date, locale = _a.locale, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, dateFormat = _a.dateFormat, onChangeDate = _a.onChangeDate, onChangeRaw = _a.onChangeRaw, id = _a.id, rest = __rest(_a, ["autoFormatDate", "customInput", "date", "locale", "minDate", "maxDate", "excludeDates", "includeDates", "filterDate", "dateFormat", "onChangeDate", "onChangeRaw", "id"]);
        if (customInput) {
            return React.cloneElement(customInput, __assign({}, rest, { ref: function (input) { return (_this.input = input); }, value: this.state.value, onBlur: this.handleBlur, onChange: this.handleChange, id: id, 'data-focus-id': id }));
        }
        else {
            return (React.createElement("input", __assign({ id: id, "data-focus-id": id, ref: function (input) { return (_this.input = input); }, type: "text" }, rest, { autoComplete: "off", spellCheck: false, value: this.state.value, onBlur: this.handleBlur, onChange: this.handleChange })));
        }
    };
    DateInput.prototype.isOtherInvalidDate = function (newValue, currentValue) {
        return typeof newValue === 'string' && newValue !== currentValue;
    };
    DateInput.prototype.resolvesToOtherDate = function (newValue, currentValue) {
        var newDate = newValue instanceof Date
            ? newValue
            : date_1.parse(newValue, this.props.dateFormat, this.props.locale);
        var currentDate = date_1.parse(currentValue, this.props.dateFormat, this.props.locale);
        var result = !(newDate === null && currentDate === null) &&
            !isSameDay(newDate, currentDate);
        return result;
    };
    DateInput.displayName = 'DateInput';
    DateInput.propTypes = {
        customInput: PropTypes.element,
        date: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        dateFormat: PropTypes.oneOfType([
            PropTypes.string.isRequired,
            PropTypes.array.isRequired
        ]),
        disabled: PropTypes.bool,
        excludeDates: PropTypes.array,
        filterDate: PropTypes.func,
        includeDates: PropTypes.array,
        locale: PropTypes.string,
        maxDate: PropTypes.object,
        minDate: PropTypes.object,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onChangeRaw: PropTypes.func,
        onChangeDate: PropTypes.func
    };
    DateInput.defaultProps = {
        dateFormat: 'DD.MM.YYYY',
        locale: 'de-de'
    };
    return DateInput;
}(React.Component));
exports.DateInput = DateInput;
exports.default = DateInput;
//# sourceMappingURL=date_input.js.map
